<template>
  <div>
    <div :class="[$style.title, 'login-heading']">
      <h1>
        <strong>PORTAL DE PAGOS</strong>
      </h1>
      <p>
        Por consultas escribinos a
        <strong>yasmin.salemco@elartedevivir.org</strong>
      </p>
    </div>
    <div :class="$style.block" v-if="!displayAccountSelection">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase">
                <strong>Ingresa los datos de acceso:</strong>
              </h4>
              <a-form class="login-form" :form="form" @submit="handleSubmit">
                <a-form-item label="Email">
                  <a-input
                    placeholder="Email"
                    v-decorator="[
                      'email',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Por favor ingresa tu nombre de usuario'
                          }
                        ]
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0,0,0,.25);"
                    />
                  </a-input>
                </a-form-item>
                <a-form-item label="Contraseña">
                  <a-input
                    placeholder="Password"
                    type="password"
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Por favor ingresa tu contraseña'
                          }
                        ]
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0,0,0,.25);"
                    />
                  </a-input>
                </a-form-item>
                <div>
                  <!--
                  <a-checkbox>Recordarme</a-checkbox>
                  -->
                  <router-link
                    class="pull-right text-primary utils__link--blue utils__link--underlined"
                    to="/user/forgot"
                    >Olvidaste tu contraseña?</router-link
                  >
                </div>
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button width-150"
                    >Ingresar</a-button
                  >
                  <!--
                  <span class="ml-3 register-link">
                    <a
                      href="javascript: void(0);"
                      class="text-primary utils__link--underlined mr-1"
                      >Registrate</a
                    >
                    si todavía no tienes una cuenta
                  </span>
                  -->
                </div>
                <!--
                <div class="form-group">
                  <p>Ingresa desde otra cuenta</p>
                  <div class="mt-2">
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-facebook" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-google" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-windows" />
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-twitter" />
                    </a>
                  </div>
                </div>
                -->
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="$style.block" v-else>
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase" style="margin-bottom:1.2rem">
                <strong>Selecciona la Cuenta</strong>
              </h4>
              <a-button
                v-for="account in accounts"
                :key="account.id"
                @click="handleSwitchAccount(account)"
                :class="$style.accountButton"
              >
                {{ account.name }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: this.$form.createForm(this),
      displayAccountSelection: false,
      accounts: []
    };
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.$nprogress.start();
          try {
            const result = await this.$auth.login(
              values.email.trim(),
              values.password
            );
            this.$nprogress.done();
            /*this.$notification["success"]({
                message: "Ingresaste",
                description: "Ingresaste correctamente al portal."
              });*/
            if (result.accounts.length > 1) {
              this.accounts = result.accounts;
              this.displayAccountSelection = true;
            } else {
              const redirect = this.$route.query.redirect || "/";
              this.$router.replace(redirect);
            }
          } catch (err) {
            let message;
            let description;
            if (err.response.status == 401) {
              message = "Error de Autenticación";
              description =
                "El email o contraseña son inválidos, por favor intente denuevo.";
            } else {
              message = `${err.response.status} ${err.response.statusText}`;
              description = err.message;
            }
            this.$nprogress.done();
            this.$notification["warning"]({
              message: message,
              description: description
            });
          }
        }
      });
    },
    async handleSwitchAccount(account) {
      if (!account.selected) {
        await this.$auth.switchAccount(account.id);
      }
      const redirect = this.$route.query.redirect || "/";
      this.$router.replace(redirect);
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
